export const UPDATE_CURRENT = "this";
export const UPDATE_CURRENT_AND_FOLLOWING = "this_and_following";
